export enum Role {
  Answerer = 0,
  StaffGuest = 1,
  Staff = 2,
  Authed = Answerer | Staff,
  All = 4,
}
